document.addEventListener("DOMContentLoaded", function () {
  console.log('✅ custom-loadmore.js loaded');

  $(document).on('click', '.js-load-more', function () {
    var $this = $(this),
        totalPages = parseInt($('[data-all-pages]').val()),
        currentPage = parseInt($('[data-this-page]').val()),
        datacollurl = $('[data-coll-url]').val();

    console.log(`📄 Total Pages: ${totalPages}, Current Page: ${currentPage}`);

    $this.attr('disabled', 'true');
    // $this.find('.load-more-text').addClass('hide');
    // $this.find('.loader').removeClass('hide');
    $this.find('.load-more-text').css('display', 'none');     // Hide
    $this.find('.loader').css('display', 'inline-block'); // Show (or 'block'/'flex' as needed)


    var nextUrl = $('[data-next-link]').val(),
        current_page_new = currentPage + 1,
        next_coll = currentPage + 2;

    console.log(`🔗 Loading next URL: ${nextUrl}`);

    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function (responseHTML) {
        console.log('✅ AJAX response received');

        const $response = $(responseHTML);
        // const $incomingGrid = $response.find('.grid--view-items');
        const $incomingGrid = $response.find('#product-grid');


        console.log('📦 Found .grid--view-items in response?', $incomingGrid.length > 0);
        // console.log('🧩 Appending HTML:', $incomingGrid.html());
        console.log('🧩 Items found:', $incomingGrid.children().length);


        // Update next link and page tracker
        $('[data-next-link]').val(datacollurl + "?page=" + next_coll);
        $('[data-this-page]').val(current_page_new);

        // Append products if available
        if ($incomingGrid.length > 0) {
          // $('.grid--view-items').append($incomingGrid.html());
          $('#product-grid').append($incomingGrid.html());

        } else {
          console.warn('⚠️ No .grid--view-items found in response. Check your selector or response structure.');
          // Optional test to verify append target works
          // $('.grid--view-items').append('<div style="border:2px dashed red;margin:10px;padding:10px;">[DEBUG] No items loaded</div>');
           $('#product-grid').append('<div style="border:2px dashed red;margin:10px;padding:10px;">[DEBUG] No items loaded</div>');
        }
      },
      complete: function () {
        if (current_page_new < totalPages) {
          $this.attr('disabled', false);
          // $this.find('.load-more-text').removeClass('hide');
          // $this.find('.loader').addClass('hide');
          $this.find('.load-more-text').css('display', 'inline-block');     // Hide
          $this.find('.loader').css('display', 'none'); // Show (or 'block'/'flex' as needed)
        }

        if (current_page_new >= totalPages) {
          $this.find('.load-more-text').text('Products Finished').removeClass('hide');
          $this.find('.loader').addClass('hide');
        }
      }
    });
  });
});
